export enum CountryCode {
  FR = 'FR',
  BE = 'BE',
}

interface Address {
  streetAddress: string;
  postalCode: string;
  city: string;
}

export interface Company {
  countryCode: CountryCode;
  name: string;
  registrationNumber: string; // SIRET for FR
  legalForm: string;
  vatNumber: string;
  address: Address;
  billingEmail: string;
}
